'use strict';

var RefreshNotificationModalController = function RefreshNotificationModalController($scope, $rootScope) {
  $scope.continueRefresh = function () {
    $rootScope.$broadcast('grid:startManualRefresh:' + $scope.gridId);
    $scope.hideModal();
  };
};
RefreshNotificationModalController.$inject = ['$scope', '$rootScope'];
module.exports = RefreshNotificationModalController;